import script from "./ProductListTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductListTile.vue?vue&type=script&setup=true&lang=js"

import "./ProductListTile.vue?vue&type=style&index=0&id=628f6eac&lang=scss"

const __exports__ = script;

export default __exports__